import { buildSectionClassname } from './classNameUtils';
import { writeBackgroundLayersToCss } from './backgroundLayerStylesUtils';
import { writeMargin, writeMaxWidthToCss, writePadding, isStyleOverridden } from './gridLayoutStyleUtils';
import combineBreakpointStyles, { buildNodeSelector, isMediaQuery } from './combineBreakpointStyles';
function writeMaxWidthToCssRuleTriple(styles, sectionSelector, breakpointConfigs, ruleTriples) {
  breakpointConfigs.forEach(config => {
    const {
      breakpointName
    } = config;
    const style = styles[breakpointName];
    if (!style) {
      return;
    }
    const selector = buildNodeSelector({
      targetSelector: `${sectionSelector} ${sectionSelector}-content`,
      breakpointConfig: config
    });
    if (style.contentWidth) {
      const styleList = [];
      writeMaxWidthToCss(style.contentWidth, styleList);
      const mediaQuery = isMediaQuery(config) ? config.mediaQuery : '';
      ruleTriples.push([selector, styleList.join(' '), mediaQuery]);
    }
  });
  return ruleTriples;
}
function writeSectionStylesToCssHelper(styles, existingStylesByBreakpointName) {
  Object.keys(styles).forEach(breakpointName => {
    const stylesForBreakpoint = existingStylesByBreakpointName[breakpointName] || [];
    const style = styles[breakpointName];
    if (isStyleOverridden(style.isHidden)) {
      stylesForBreakpoint.push(`display: ${style.isHidden ? 'none' : 'block'};`);
    }
    if (isStyleOverridden(style.padding)) {
      stylesForBreakpoint.push(writePadding(style.padding));
    }
    if (isStyleOverridden(style.margin)) {
      stylesForBreakpoint.push(writeMargin(style.margin));
    }
    existingStylesByBreakpointName[breakpointName] = stylesForBreakpoint;
  });
}
export default function writeSectionStylesToCss(nodeId, styles, breakpointConfigs) {
  const nodeSelector = `.${buildSectionClassname(nodeId)}`;
  const stylesByBreakpointName = {};
  const backgroundLayerStylesByBreakpointName = {};
  const backgroundLayersByBreakpointName = Object.keys(styles).reduce((acc, breakpointName) => {
    const stylesForBreakpoint = styles[breakpointName];
    if (stylesForBreakpoint !== null && stylesForBreakpoint !== void 0 && stylesForBreakpoint.backgroundLayers) {
      acc[breakpointName] = stylesForBreakpoint.backgroundLayers;
    }
    return acc;
  }, {});
  writeBackgroundLayersToCss(nodeId, backgroundLayersByBreakpointName, backgroundLayerStylesByBreakpointName);
  writeSectionStylesToCssHelper(styles, stylesByBreakpointName);
  const combinedBreakpointStyles = combineBreakpointStyles(breakpointConfigs, stylesByBreakpointName, nodeId, backgroundLayerStylesByBreakpointName, nodeSelector);
  writeMaxWidthToCssRuleTriple(styles, nodeSelector, breakpointConfigs, combinedBreakpointStyles);
  return combinedBreakpointStyles;
}